import type { ApiQuery, ApiRequestBody, ApiResponse } from "@takt/api-contracts"
import type { ApiClient } from "../client"
import type { PaginatedQuery } from "./query-types"

export type UsersQuery = PaginatedQuery<NonNullable<ApiQuery<"/v1/users", "get">>>
export type UsersResponse = ApiResponse<"/v1/users", "get", 200>
export type UserResponse = ApiResponse<"/v1/users/{userId}", "get", 200>
export type UpdateUserInput = ApiRequestBody<"/v1/users/{userId}", "patch">
export type CurrentUserSettings = ApiResponse<"/v1/users/me/settings", "get", 200>
export type UpdateCurrentUserSettingsInput = ApiRequestBody<"/v1/users/me/settings", "patch">

export function createUserEndpoints(client: ApiClient) {
    return {
        listUsers(query: UsersQuery = {}) {
            return client.get<UsersResponse>("/users", { query })
        },
        getUser(userId: string) {
            return client.get<UserResponse>(`/users/${encodeURIComponent(userId)}`)
        },
        updateUser(userId: string, input: UpdateUserInput) {
            return client.patch<ApiResponse<"/v1/users/{userId}", "patch", 200>>(
                `/users/${encodeURIComponent(userId)}`,
                input,
            )
        },
        deleteUser(userId: string) {
            return client.delete<null>(`/users/${encodeURIComponent(userId)}`)
        },
        getCurrentUserSettings() {
            return client.get<CurrentUserSettings>("/users/me/settings")
        },
        updateCurrentUserSettings(input: UpdateCurrentUserSettingsInput) {
            return client.patch<ApiResponse<"/v1/users/me/settings", "patch", 200>>("/users/me/settings", input)
        },
    }
}
